import { FaEdit, FaPlus } from 'react-icons/fa';
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  HStack,
  StackProps,
  Tooltip,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

interface TableControlsProps extends StackProps {
  addAction?: () => void;
  editAction?: () => void;
  search?: string;
  setSearch?: (search: string) => void;
}

export const TableControls: React.FC<TableControlsProps> = ({
  addAction,
  editAction,
  search,
  setSearch,
}) => {
  return (
    <HStack marginY="2">
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.400" boxSize={4} />
        </InputLeftElement>
        <Input
          onChange={setSearch ? (e) => setSearch(e.target.value) : undefined}
          placeholder="Search"
          value={search}
        ></Input>
      </InputGroup>
      {addAction && <Tooltip label="Create New">
        <IconButton
          variant="ghost"
          aria-label="create-new"
          icon={<FaPlus />}
          onClick={addAction}
        />
      </Tooltip>}
      {editAction && <Tooltip label="Edit">
        <IconButton
          variant="ghost"
          aria-label="select-multiple"
          icon={<FaEdit />}
          onClick={editAction}
        />
      </Tooltip>}
    </HStack>
  );
};
